<template>
  <div>
    <div class="mb-4">
      <div class="w-full mb-4">
        <strong>{{ name }}</strong>
      </div>

      <div class="w-full">
        <v-select 
          label="description" 
          :options="items" 
          v-model="selected"
          :name="'select' + index" 
          v-validate="isRequired ? 'required' : '' "
          :disabled="disabled"
        ></v-select>

        <span class="text-danger text-sm" v-show="errors.has('select' + index)">
          Preenchimento do campo é obrigatório.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'

  export default {
    name: 'SelectField',
    inject: ['$validator'],
    components:{vSelect},
    props: {
      index: {
        type: Number,
        required: true
      },
      items: {
        type: Array,
        required: false
      },
      description: {
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data() {
      return {
        selected: null,
        isRequired: false
      }
    },
    computed:  {
      name(){
        if ( !this.description || this.description.description == ''){
          return;
        } 
        else if ( this.description.description ){
          return this.description.description;
        }
        return this.description;
      }
    },
    watch: {
      selected (value) {
        this.items.forEach((item, idx) => {
          let flag = item.reason_option_item_id === value.reason_option_item_id
          this.$emit('valueChanged', this.index, idx, flag)
        })
      }
    }, 
    created() {
      if (!this.items) { return;}
      this.items.forEach((item) => {
        this.isRequired = item.reason_option_is_required

        if (!item.value) { return false; }
        this.selected = item.value.toLowerCase() == 'true' ? item : false
      })
    }
  }
</script>